// extracted by mini-css-extract-plugin
module.exports = {"background":"unitView_background__2Alz9"};
    if(module.hot) {
      // 1744882511543
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  